import React, { useState } from 'react';
import { Modal, Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TinySlider from 'tiny-slider-react';

import TopperImage from '../assets/images/new-kbs-image.jpg';
import TopperImageNew from '../assets/images/kbs-new-02-07-2025.jpg';
import HomeNew from '../assets/images/home-new-img.jpg';
import Result2026_4 from '../assets/images/result-2026-4.jpg';
import Result2026_1 from '../assets/images/result-2026-1.jpg';
import Result2026_2 from '../assets/images/result-2026-2.jpg';
import Result2026_3 from '../assets/images/result-2026-3.jpg';
import TopperImage1 from '../assets/images/kbs-new-img-1.jpg';
import TopperImage2 from '../assets/images/kbs-new-img-2.jpg';
import TopperImage3 from '../assets/images/kbs-new-img-3.jpg';
import TopperImage4 from '../assets/images/kbs-new-img-4.jpg';
import TopperImage5 from '../assets/images/kbs-new-img-5.jpg';
import TopperImage6 from '../assets/images/kbs-new-img-6.jpg';
import TopperImage7 from '../assets/images/kbs-new-img-7.jpg';
import TopperImage8 from '../assets/images/kbs-new-img-8.jpg';
import TopperImage9 from '../assets/images/kbs-new-img-9.jpg';

// Image array
const imageArray = [
  HomeNew,
  Result2026_4,
  Result2026_1,
  Result2026_2,
  Result2026_3
  // TopperImage,
  // TopperImage1,
  // TopperImage2,
  // TopperImage3,
  // TopperImage4,
  // TopperImage5,
  // TopperImage6,
  // TopperImage7,
  // TopperImage8,
  // TopperImage9,
];

// TinySlider settings
const sliderSettings = {
  items: 1,
  slideBy: 'page',
  autoplay: true,
  autoplayTimeout: 3000,
  controls: false,
  nav: false,
  loop: true,
  mouseDrag: true,
  gutter: 0,
  autoplayButtonOutput: false, // This hides the "stop" button
};

// Modal style
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100vw',
  maxWidth: 650,
  height: 'auto',
  bgcolor: '#000',
  boxShadow: 24,
  borderRadius: 4,
  outline: 'none',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
};

const ModalVideoC = () => {
  const [open, setOpen] = useState(true);
  const handleClose = () => setOpen(false);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        {/* Modal Header */}
        <Box
          sx={{
            width: '100%',
            px: 2,
            py: 1,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            background: 'rgba(0,0,0,0.6)',
            zIndex: 2,
            position: 'relative',
          }}
        >
          {/* <Typography sx={{ color: '#fff', fontSize: 14 }}>
            Latest Results
          </Typography> */}
          <IconButton onClick={handleClose} sx={{ color: '#fff' }}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Slider */}
        <Box sx={{ width: '100%', }}>
          <TinySlider settings={sliderSettings}>
            {imageArray.map((img, idx) => (
              <Box
                key={idx}
                component="img"
                src={img}
                alt={`Topper ${idx + 1}`}
                sx={{
                  width: '100%',
                  display: 'block',
                  height: '600px',
                  objectFit: 'contain',
                  backgroundColor: '#000',
                }}
              />
            ))}
          </TinySlider>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalVideoC;
